import tipotLogo from 'assets/images/tipot-logo.png';

const Loading = () => {
    return (
        <div className="flex flex-col items-center justify-center py-16 bg-white rounded-3xl">
            <img
                src={tipotLogo}
                alt="Tipot"
                className="w-16 h-16 object-contain"
                style={{
                    animation: 'heartbeat 1.2s ease-in-out infinite',
                }}
            />
            <style>{`
                @keyframes heartbeat {
                    0%, 100% { transform: scale(1); opacity: 0.7; }
                    15% { transform: scale(1.15); opacity: 1; }
                    30% { transform: scale(1); opacity: 0.7; }
                    45% { transform: scale(1.1); opacity: 0.9; }
                    60% { transform: scale(1); opacity: 0.7; }
                }
            `}</style>
        </div>
    );
}

export default Loading;
